export default function loadLocale(locale) {
  return new Promise((resolve) => {
    switch (locale) {
    case 'en':
  
      case 'en-US': {
      if (typeof require.ensure === 'function') {
        return require.ensure('./en-US', (require) => {
          const data = require('./en-US');
          return resolve(data.__esModule === true ? data.default : data);
        }, 'en-US');
      } else {
          const data = require('./en-US');
          return resolve(data.__esModule === true ? data.default : data);
      }
      }
      case 'en-GB': {
      if (typeof require.ensure === 'function') {
        return require.ensure('./en-GB', (require) => {
          const data = require('./en-GB');
          return resolve(data.__esModule === true ? data.default : data);
        }, 'en-GB');
      } else {
          const data = require('./en-GB');
          return resolve(data.__esModule === true ? data.default : data);
      }
      }
      case 'en-CA': {
      if (typeof require.ensure === 'function') {
        return require.ensure('./en-CA', (require) => {
          const data = require('./en-CA');
          return resolve(data.__esModule === true ? data.default : data);
        }, 'en-CA');
      } else {
          const data = require('./en-CA');
          return resolve(data.__esModule === true ? data.default : data);
      }
      }
      case 'en-AU': {
      if (typeof require.ensure === 'function') {
        return require.ensure('./en-AU', (require) => {
          const data = require('./en-AU');
          return resolve(data.__esModule === true ? data.default : data);
        }, 'en-AU');
      } else {
          const data = require('./en-AU');
          return resolve(data.__esModule === true ? data.default : data);
      }
      }
    case 'fr':
  
      case 'fr-FR': {
      if (typeof require.ensure === 'function') {
        return require.ensure('./fr-FR', (require) => {
          const data = require('./fr-FR');
          return resolve(data.__esModule === true ? data.default : data);
        }, 'fr-FR');
      } else {
          const data = require('./fr-FR');
          return resolve(data.__esModule === true ? data.default : data);
      }
      }
      case 'fr-CA': {
      if (typeof require.ensure === 'function') {
        return require.ensure('./fr-CA', (require) => {
          const data = require('./fr-CA');
          return resolve(data.__esModule === true ? data.default : data);
        }, 'fr-CA');
      } else {
          const data = require('./fr-CA');
          return resolve(data.__esModule === true ? data.default : data);
      }
      }
    case 'de':
  
      case 'de-DE': {
      if (typeof require.ensure === 'function') {
        return require.ensure('./de-DE', (require) => {
          const data = require('./de-DE');
          return resolve(data.__esModule === true ? data.default : data);
        }, 'de-DE');
      } else {
          const data = require('./de-DE');
          return resolve(data.__esModule === true ? data.default : data);
      }
      }
    case 'it':
  
      case 'it-IT': {
      if (typeof require.ensure === 'function') {
        return require.ensure('./it-IT', (require) => {
          const data = require('./it-IT');
          return resolve(data.__esModule === true ? data.default : data);
        }, 'it-IT');
      } else {
          const data = require('./it-IT');
          return resolve(data.__esModule === true ? data.default : data);
      }
      }
    case 'es':
  
      case 'es-ES': {
      if (typeof require.ensure === 'function') {
        return require.ensure('./es-ES', (require) => {
          const data = require('./es-ES');
          return resolve(data.__esModule === true ? data.default : data);
        }, 'es-ES');
      } else {
          const data = require('./es-ES');
          return resolve(data.__esModule === true ? data.default : data);
      }
      }
      case 'es-419': {
      if (typeof require.ensure === 'function') {
        return require.ensure('./es-419', (require) => {
          const data = require('./es-419');
          return resolve(data.__esModule === true ? data.default : data);
        }, 'es-419');
      } else {
          const data = require('./es-419');
          return resolve(data.__esModule === true ? data.default : data);
      }
      }
    case 'ja':
  
      case 'ja-JP': {
      if (typeof require.ensure === 'function') {
        return require.ensure('./ja-JP', (require) => {
          const data = require('./ja-JP');
          return resolve(data.__esModule === true ? data.default : data);
        }, 'ja-JP');
      } else {
          const data = require('./ja-JP');
          return resolve(data.__esModule === true ? data.default : data);
      }
      }
    case 'pt':
  
      case 'pt-BR': {
      if (typeof require.ensure === 'function') {
        return require.ensure('./pt-BR', (require) => {
          const data = require('./pt-BR');
          return resolve(data.__esModule === true ? data.default : data);
        }, 'pt-BR');
      } else {
          const data = require('./pt-BR');
          return resolve(data.__esModule === true ? data.default : data);
      }
      }
    case 'zh':
  
      case 'zh-CN': {
      if (typeof require.ensure === 'function') {
        return require.ensure('./zh-CN', (require) => {
          const data = require('./zh-CN');
          return resolve(data.__esModule === true ? data.default : data);
        }, 'zh-CN');
      } else {
          const data = require('./zh-CN');
          return resolve(data.__esModule === true ? data.default : data);
      }
      }
      case 'zh-TW': {
      if (typeof require.ensure === 'function') {
        return require.ensure('./zh-TW', (require) => {
          const data = require('./zh-TW');
          return resolve(data.__esModule === true ? data.default : data);
        }, 'zh-TW');
      } else {
          const data = require('./zh-TW');
          return resolve(data.__esModule === true ? data.default : data);
      }
      }
      case 'zh-HK': {
      if (typeof require.ensure === 'function') {
        return require.ensure('./zh-HK', (require) => {
          const data = require('./zh-HK');
          return resolve(data.__esModule === true ? data.default : data);
        }, 'zh-HK');
      } else {
          const data = require('./zh-HK');
          return resolve(data.__esModule === true ? data.default : data);
      }
      }
      default:
        return resolve(null);
    }
  });
}
